import axios from 'axios'

/**
 * v1 API
 * @version  1
 */
export default class v1 {
  constructor(session) {
    const $axios = axios.create({
      baseURL: `${process.env.VUE_APP_API_HOST}/v2`,
      headers: {
        'Authorization': `Bearer ${session.get('token')}`,
      }
    })
  }
}
